/* @flow */

import PropTypes from 'prop-types';
import { compose, getContext, mapProps, withHandlers, withState } from 'recompose';
import { omit } from 'lodash/fp';

const omitProps = compose(
  mapProps,
  omit
);

const withTimer = compose(
  getContext({
    timer: PropTypes.shape({
      subscribe: PropTypes.func.isRequired,
      unsubscribe: PropTypes.func.isRequired
    }).isRequired
  }),
  withState('timestamp', 'setTimestamp', Date.now),
  withHandlers({
    subscribe({ setTimestamp, timer }) {
      return () => {
        timer.subscribe(setTimestamp);
      };
    },
    unsubscribe({ setTimestamp, timer }) {
      return () => {
        timer.unsubscribe(setTimestamp);
      };
    }
  }),
  omitProps(['setTimestamp', 'timer'])
);

export default withTimer;
